import React from "react";
import { Link } from "react-router-dom";

import classes from "./Category.module.css";

function CategoryCard({ data }) {
  return (
    <div className={classes.card}>
      <Link to={`/category/${data.category}`}>
        <span>
          <h2>{data.category}</h2>
        </span>

        <img src={data.image} alt={data.title} />
        <p>Shop Now</p>
      </Link>
    </div>
  );
}

export default CategoryCard;
